<template>
  <div class="the-background" :class="classes"></div>
</template>

<script>
export default {
  name: "TheBackground",
  computed: {
    isSmall() {
      return this.$route.name !== "home";
    },
    classes() {
      return {
        "the-background_small": this.isSmall
      };
    }
  }
};
</script>

<style lang="scss">
$p: ".the-background";

.the-background {
  position: absolute;
  top: -90px;
  left: 50%;
  z-index: -1;
  transform: translateX(-50%);
  bottom: 0;
  width: 100%;
  background: url("~@/assets/images/main-bg2.jpg") 50% 0 no-repeat;
  /* background-size: auto 1203px; */
  /* background-size: auto 900px; */

  &_small {
    background-size: auto 900px;
  }

  .content_iframe & {
    top: 0;
  }

  @include breakpoint("lg-and-down") {
    background-size: auto 900px;
  }
  @include breakpoint("md-and-down") {
    background-size: auto 900px;
  }
  @include breakpoint("sm-and-down") {
    top: -40px;
    background-size: auto 570px;
  }
  @include breakpoint("xs-only") {
  }
}
</style>
